// https://stackoverflow.com/a/5379408
export const isTextHighlighted = () => window.getSelection().toString().length > 0;
